import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAllCategories } from "../../redux/Slices/CategorySlice";
import { GetAllBrands } from "../../redux/Slices/BrandsSlice";
import { getSubCatONMainCat } from "../../redux/Slices/SubCategorySlice";
import { addNewProduct } from "../../redux/Slices/ProductSlice";
import notify from "../UseNotification";

const UseAddProduct = () => {

  const dispatch = useDispatch();
  const [allCategories, setallCategories] = useState("");
  const [allbrands, setallBrands] = useState("");
  const [categoryLoading, setCategoryLoading] = useState(true);
  const [brandsLoading, setBrandsLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [qty, setQty] = useState("");
  const [priceBeforeDiscount, setPriceBeforeDiscount] = useState("");
  const [productprice, setProductprice] = useState("");
  const [categoryValue, setCategoryValue] = useState("");
  const [BrandValue, setBrandValue] = useState("")
  const [toggleColor, setToggleColor] = useState(false);
  const [colors, setColors] = useState([]);
  const [images, setImages] = useState([]);
  const [isValidate, setIsValidate] = useState(false);
  const [isPress, setIspress] = useState(false);

  const { AllCategories } = useSelector((state) => state.CategoryReducer);
  const { AllBrands } = useSelector((state) => state.BrandsReducer);
  const { allProducts } = useSelector((state) => state.ProductReducer);

  const [options, setOptions] = useState([]);
  const [selectedSubCat, setSelectedSubCat] = useState();

  // get all categories
  const getAllCategories = async () => {
    setCategoryLoading(true)
    await dispatch(GetAllCategories(`page="1"`));
    setCategoryLoading(false)
  }

  // get all brands
  const getAllBrands = async () => {
    setBrandsLoading(true)
    await dispatch(GetAllBrands(`page="1"`));
    setBrandsLoading(false)
  }

  // run get all categories && get all brands
  useEffect(() => {
    getAllCategories();
    getAllBrands();
  }, []);

  // handle get all categories response
  useEffect(() => {
    if (categoryLoading === false) {
      if (AllCategories && AllCategories.data) {
        setallCategories(AllCategories.data)
      }
    }
  }, [categoryLoading])

  // handle get all brands response
  useEffect(() => {
    if (brandsLoading === false) {
      if (AllBrands && AllBrands.data) {
        setallBrands(AllBrands.data)
      }
    }
  }, [brandsLoading])

  // to set  product name
  const OnChangeProductName = (e) => {
    e.persist();
    setProductName(e.target.value);
  };

  // to set  product discription
  const onChangeProductDescription = (e) => {
    e.persist();
    setProductDescription(e.target.value);
  };

  // to set qty products
  const onChangeqty = (e) => {
    e.persist();
    setQty(e.target.value);
  };


  // set Price before discount
  const onChangePriceBeforeDiscount = (e) => {
    e.persist();
    setPriceBeforeDiscount(e.target.value);
  };

  // set product price after discount
  const onChangeProductprice = (e) => {
    e.persist();
    setProductprice(e.target.value);
  };

  // set Category value
  const onChangeCategoryValue = (e) => {
    e.persist();
    setCategoryValue(e.target.value);
  };


  // set brand value
  const onChangeBrandValue = (e) => {
    e.persist();
    setBrandValue(e.target.value);
  };

  //   toggle color option
  const onToggleColor = () => {
    setToggleColor(!toggleColor);
  };

  // save Color Value
  const SaveColorValue = (color) => {
    setColors([...colors, color.hex]);
    setToggleColor(!toggleColor);
  };

  // to delete color
  const deleteColor = (color) => {
    const newColors = colors.filter((e) => e !== color);
    setColors(newColors);
  };


  // convert image from base 64 to file to we can save it
  function dataURLtoFile(dataurl, filename) {

    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  // validate Product Name
  const validateProductName = (e) => {
    if (e.target.value === "") (
      notify("Please enter product name", "error")
    )
  }

  // validate Product Description
  const validateProductDescription = (e) => {
    if (e.target.value === "") (
      notify("Please enter product Description", "error")
    )
  }

  // validate Product qty
  const validateProductqty = (e) => {
    if (e.target.value === "") (
      notify("Please enter product quantity", "error")
    )
  }

  // validate Price Before Discount
  const validatePriceBeforeDiscount = (e) => {
    if (e.target.value === "") (
      notify("Please enter price before discount ", "error")
    )
    if (e.target.value < productprice) {
      notify("price before discount must > price after discount", "error")
    }
  }

  // validate Product price
  const validateProductprice = (e) => {
    // if (e.target.value === "") (
    //   notify("Please enter price after discount ", "error")
    // )
    if (e.target.value > priceBeforeDiscount) {
      notify("price after discount must < price before discount", "error")
    }
  }

  // check if the image object is empty or not 
  const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  };

  // handle validate for the disable button
  useEffect(() => {
    if (images && productName && productDescription && qty && priceBeforeDiscount && categoryValue && BrandValue && !isObjectEmpty(images) && productName != "" && productDescription != "" && qty != "" && priceBeforeDiscount != "" && categoryValue != "" && BrandValue != "") {
      setIsValidate(true)
    } else {
      setIsValidate(false)
    }
  }, [images, productName, productDescription, qty, priceBeforeDiscount, categoryValue, BrandValue])


  // const validate function
  const validate = () => {
    if (images && productName && productDescription && qty && priceBeforeDiscount && categoryValue && BrandValue && isObjectEmpty(images) && productName === "" && productDescription === "" && qty === "" && priceBeforeDiscount === "" && categoryValue === "" && BrandValue === "") {
      return;
    } else {
    }
  }
  // get selected subCategory
  const onSelect = (selectedValue) => {
    setSelectedSubCat(selectedValue);
  };
  const onRemove = (selectedValue) => {
    setSelectedSubCat(selectedValue);
  };
  const multiselectRef = useRef();
  const resetValues = () => {
    if (multiselectRef.current) {
      multiselectRef.current.resetSelectedValues();
    }
  };
  useEffect(() => {
    dispatch(getSubCatONMainCat(categoryValue));
  }, [categoryValue]);

  // useEffect(() => {
  //   if (categoryValue != 0) {
  //     if (SubCategory.length >= 1) {
  //       setOptions(SubCategory);
  //     }
  //   }
  // }, [SubCategory]);




  // submit form
  const SubmitForm = async (e) => {
    e.preventDefault();
    validate();
    setIspress(true)
    // convert one image to file
    const imgCover = dataURLtoFile(images[0], Math.random() + ".png");
    // convert array of images base 64 image to file
    const itemImages = Array.from(Array(Object.keys(images).length).keys()).map(
      (item, index) => {
        return dataURLtoFile(images[index], Math.random() + ".png");
      }
    );
    const formData = new FormData();
    formData.append("imageCover", imgCover);
    formData.append("title", productName);
    formData.append("description", productDescription);
    formData.append("quantity", qty);
    formData.append("category", categoryValue);
    formData.append("price", priceBeforeDiscount);
    if (productprice !== "") {
      formData.append("priceAfterDiscount", productprice);
    }
    formData.append("brand", BrandValue);
    colors?.map((color) => formData.append("availableColors", color));
    selectedSubCat?.map((item) => formData.append("subcategory", item._id));
    itemImages?.map((item) => formData.append("images", item));
    setLoading(true);
    await dispatch(addNewProduct(formData));
    setLoading(false);
  };


  useEffect(() => {
    if (loading === false) {
      if (allProducts && allProducts.status === 201) {
        notify("Done", "success");
        setTimeout(() => {
          window.location.reload(false)
        }, 1000)
      } else {
        notify(allProducts.response.message, "error");
      }
    }
  }, [loading]);




  return [
    loading,
    isPress,
    isValidate,
    images,
    onSelect,
    onRemove,
    setImages,
    productName,
    OnChangeProductName,
    productDescription,
    onChangeProductDescription,
    priceBeforeDiscount,
    onChangePriceBeforeDiscount,
    productprice,
    onChangeProductprice,
    categoryValue,
    onChangeCategoryValue,
    BrandValue,
    onChangeBrandValue,
    allCategories,
    allbrands,
    SubmitForm,
    onToggleColor,
    toggleColor,
    SaveColorValue,
    colors,
    deleteColor,
    options,
    qty,
    onChangeqty,
    multiselectRef,
    validateProductName,
    validateProductDescription,
    validateProductqty,
    validatePriceBeforeDiscount,
    validateProductprice
  ];
};

export default UseAddProduct;
